import { render, staticRenderFns } from "./BrandContentItem.vue?vue&type=template&id=56b52a9f&scoped=true&"
import script from "./BrandContentItem.vue?vue&type=script&lang=js&"
export * from "./BrandContentItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandContentItem.vue?vue&type=style&index=0&id=56b52a9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b52a9f",
  null
  
)

export default component.exports